import React, { useRef } from "react";

/**
 * 3D-Neige-Effekt für Karten (wie bei Apple-Produktkarten): kippt leicht in Richtung Cursor
 * innerhalb der Karte, mit einem dezenten Glanzlicht das der Maus folgt. Läuft komplett über
 * ref/DOM statt React-State, damit jede Mausbewegung sofort und ruckelfrei reagiert.
 *
 * Nutzung: <TiltCard className="...">Inhalt</TiltCard> - rendert einen <div> als Wrapper.
 */
export function TiltCard({ children, className = "", maxTilt = 8, glare = true, as: Tag = "div", ...props }) {
  const cardRef = useRef(null);
  const glareRef = useRef(null);

  const onMouseMove = (e) => {
    const el = cardRef.current;
    if (!el || window.matchMedia("(pointer: coarse)").matches) return;
    const rect = el.getBoundingClientRect();
    const px = (e.clientX - rect.left) / rect.width;  // 0..1
    const py = (e.clientY - rect.top) / rect.height;   // 0..1
    const rotateY = (px - 0.5) * maxTilt * 2;
    const rotateX = (0.5 - py) * maxTilt * 2;
    el.style.transform = `perspective(800px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.02,1.02,1.02)`;
    if (glare && glareRef.current) {
      glareRef.current.style.background = `radial-gradient(circle at ${px * 100}% ${py * 100}%, rgba(255,255,255,0.35) 0%, rgba(255,255,255,0) 60%)`;
      glareRef.current.style.opacity = "1";
    }
  };

  const onMouseLeave = () => {
    const el = cardRef.current;
    if (el) el.style.transform = "perspective(800px) rotateX(0deg) rotateY(0deg) scale3d(1,1,1)";
    if (glareRef.current) glareRef.current.style.opacity = "0";
  };

  return (
    <Tag
      ref={cardRef}
      onMouseMove={onMouseMove}
      onMouseLeave={onMouseLeave}
      className={`relative ${className}`}
      style={{ transition: "transform 0.35s cubic-bezier(0.16,1,0.3,1)", transformStyle: "preserve-3d", willChange: "transform" }}
      {...props}
    >
      {children}
      {glare && (
        <div
          ref={glareRef}
          className="absolute inset-0 pointer-events-none rounded-[inherit]"
          style={{ opacity: 0, transition: "opacity 0.3s ease" }}
        />
      )}
    </Tag>
  );
}
